import React from 'react';
import { ReactElement } from "react";
import SelectorItem, { ISelectorItemProps } from "Pages/ProductPricing/SelectorItem";

interface ISelectorProps {
    id?: string;
    title: string;
    value?: number;
    onValueChanged?: ((sender: Selector, value?: number) => void);
}

interface ISelectorState {
    value?: number;
}

export default class Selector extends React.Component<ISelectorProps, ISelectorState> {
    constructor(props: ISelectorProps) {
        super(props);
        this.state = {
            value: this.props.value
        }
        this.handleItemClick = this.handleItemClick.bind(this);
    }

    private handleItemClick(sender: SelectorItem): void {
        this.setState({value: sender.props.value}, () => {
            this.props.onValueChanged?.(this, this.state.value!);
        });
    }

    public render() {
        return (
            <div id={this.props.id} className="selector">
                <h3 className="title">{this.props.title}</h3>
                <div className="content">
                    {React.Children.map(this.props.children, child => {
                        let anyChild = child as ReactElement<any>;
                        if (!anyChild) {
                            return undefined;
                        } else if (anyChild.type == SelectorItem) {
                            let typedChild = child as ReactElement<ISelectorItemProps>;
                            let props: Partial<ISelectorItemProps> = {
                                selected: typedChild.props.value == this.state.value,
                                onClick: this.handleItemClick
                            };
                            return React.cloneElement(typedChild, props);
                        } else {
                            return child;
                        }
                    })}
                </div>
            </div>
        );
    }
}